import React from 'react';
import CandidatesOverviewList from './Components/CandidatesOverviewList';
import { CandidatesOverviewContext } from './Contexts/CandidatesOverviewContext/CandidatesOverviewContext';
import useCandidatesOverviewContextValue from './Contexts/CandidatesOverviewContext/UseCandidatesOverviewContextValue';
import CandidatesOverviewHeader from './Components/CandidatesOverviewHeader';
import { ActionDialogContext } from '../components/dialogs/Context/ActionDialogContext';
import useActionDialogContextValue from '../components/dialogs/Context/ActionDialogContextValue';
import withTalentMeshUserRequired from '@/Routing/withTalentMeshUserRequired';
import withSignupChecks from '@/Routing/withSignupChecks';
import withCompanyProfileRequired from '@/Routing/withCompanyProfileRequired';
import CandidateOverviewDialogs from './Components/CandidateOverviewDialogs';
import { CandidatesTableContext, useCandidatesTable } from './Contexts/CandidatesTableContext/CandidatesTableContext';
import CandidatesPageLayout from '../components/CandidatesPageLayout';
import CandidatesOverviewPageNavigationSidebar from './Components/CandidatesOverviewPageNavigationSidebar';
import { useRecruitmentId } from '@/Hooks';

const CandidatesOverviewPage = () => {
    const recruitmentId = useRecruitmentId();
    const contextValue = useCandidatesOverviewContextValue(recruitmentId);
    const dialogContextValue = useActionDialogContextValue();
    const candidatesTable = useCandidatesTable(contextValue);

    return (
        <ActionDialogContext.Provider value={dialogContextValue}>
            <CandidatesOverviewContext.Provider value={contextValue}>
                <CandidatesTableContext.Provider value={candidatesTable}>
                    <CandidatesPageLayout sidebar={<CandidatesOverviewPageNavigationSidebar />}>
                        <CandidatesOverviewHeader />
                        <CandidatesOverviewList />
                        <CandidateOverviewDialogs />
                    </CandidatesPageLayout>
                </CandidatesTableContext.Provider>
            </CandidatesOverviewContext.Provider>
        </ActionDialogContext.Provider>
    );
};

export default withCompanyProfileRequired(withTalentMeshUserRequired(withSignupChecks(CandidatesOverviewPage)));
